module.exports = __webpack_public_path__ + "img/ma215.805aaff3.png";